export const RightIconSizeMap = {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'MEDIUM',
};
const input = {
    size: {
        SMALL: {
            height: '1.75rem',
            padding: '0.25rem 0.5rem',
            fontSize: '0.875rem',
            leftIconPadding: '0.25rem 0.25rem 0.25rem 0.5rem',
            rightIconPadding: '0.375rem 0.5rem 0.375rem 0.125rem',
            containerRightIconPadding: '1.5rem',
        },
        MEDIUM: {
            height: '2.25rem',
            padding: '0.4375rem 0.75rem',
            fontSize: '1rem',
            leftIconPadding: '0.5rem 0.25rem 0.5rem 0.5rem',
            rightIconPadding: '0.5rem 0.5rem 0.5rem 0.125rem',
            containerRightIconPadding: '1.75rem',
        },
        LARGE: {
            height: '2.5rem',
            padding: '0.4375rem 0.75rem',
            fontSize: '1.25rem',
            leftIconPadding: '0.625rem 0.25rem 0.625rem 0.5rem',
            rightIconPadding: '0.625rem 0.5rem 0.625rem 0.125rem',
            containerRightIconPadding: '1.75rem',
        },
    },
    status: {
        default: {
            backgroundColor: 'SNOW_100',
            borderColor: 'INK_300',
            textColor: 'INK_800',
        },
        hover: {
            backgroundColor: 'SNOW_100',
            borderColor: 'PRIMARY_600',
            textColor: 'INK_800',
        },
        disabled: {
            backgroundColor: 'SNOW_300',
            borderColor: 'INK_300',
            textColor: 'INK_600',
        },
        invalid: {
            backgroundColor: 'SNOW_100',
            borderColor: 'RED_600',
            textColor: 'INK_800',
        },
        invalidHover: {
            backgroundColor: 'SNOW_100',
            borderColor: 'RED_700',
            textColor: 'INK_800',
        },
    },
};
export default input;
//# sourceMappingURL=inputs.js.map